import {
  yesNoSchema,
  yesNoUI,
  titleUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import { AdditionalDependentsAlert } from '../../../components/FormAlerts';
import content from '../../../utils/content.json';

/** @type {PageSchema} */
export default {
  uiSchema: {
    ...titleUI(content['household-dependents-residence-title']),
    childrenLiveTogetherButNotWithSpouse: yesNoUI({
      title: content['household-dependents-residence-question'],
    }),
    residenceAlert: {
      'ui:description': AdditionalDependentsAlert,
      'ui:options': {
        // Should hide if undefined when first landing on page or true/yes.
        hideIf: formData =>
          formData?.childrenLiveTogetherButNotWithSpouse !== false,
        displayEmptyObjectOnReview: true,
      },
    },
  },
  schema: {
    type: 'object',
    required: ['childrenLiveTogetherButNotWithSpouse'],
    properties: {
      childrenLiveTogetherButNotWithSpouse: yesNoSchema,
      residenceAlert: {
        type: 'object',
        properties: {},
      },
    },
  },
};
